import { type ReactNode } from 'react';
import { Box } from '@mentimeter/ragnar-ui/box';
import { EDITOR_MOBILE_OVERVIEW_CONTAINER_HEIGHT } from '@mentimeter/editor-slides-popover/constants';
import { FOOTER_ACTIONS_HEIGHT_MOBILE } from '@mentimeter/editor-properties-pane/';

export const EDITOR_MOBILE_LAYOUT_ACTION_PANE_ID =
  'editor-mobile-layout-action-pane';

interface EditorMobileLayoutProps {
  isPaneOpen: boolean;
  canvas: ReactNode;
  slidesOverview: ReactNode;
  actions?: ReactNode;
  footer?: ReactNode;
  actionsAlign: 'top' | 'bottom';
}

export function EditorMobileLayout({
  isPaneOpen,
  canvas,
  slidesOverview,
  actions,
  footer,
  actionsAlign,
}: EditorMobileLayoutProps) {
  const bottomHeight = `calc(${EDITOR_MOBILE_OVERVIEW_CONTAINER_HEIGHT}px + ${footer ? FOOTER_ACTIONS_HEIGHT_MOBILE : '0px'})`;

  return (
    <Box
      as="main"
      display="flex"
      flexDirection="column"
      height="100%"
      width="100%"
      bg="surfaceSunken"
      alignItems="stretch"
    >
      <Box
        p="space2"
        flex={isPaneOpen ? 'none' : '1'}
        flexDirection="column"
        justifyContent="flex-end"
      >
        {canvas}
      </Box>
      <Box
        id={EDITOR_MOBILE_LAYOUT_ACTION_PANE_ID}
        alignItems="center"
        flexDirection="column"
        width="100%"
        flex="1"
        justifyContent={actionsAlign === 'bottom' ? 'flex-end' : 'flex-start'}
      >
        {actions}
      </Box>
      <Box
        position="absolute"
        bottom={actionsAlign === 'bottom' ? FOOTER_ACTIONS_HEIGHT_MOBILE : '0'}
        width="100%"
        id="editor-overview-container"
        height={bottomHeight}
        display="flex"
        flexDirection="column"
        justifyContent={isPaneOpen ? 'flex-start' : 'center'}
        alignItems="center"
      >
        {slidesOverview}
      </Box>
    </Box>
  );
}
